import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useEvents } from "@/lib/hooks/use-events";
import type { UserUpdatedPayload } from "@/lib/types/events";

export function useMentorshipUserUpdates(mentorshipId: string | null) {
  const { addEventListener } = useEvents();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!mentorshipId) return;

    return addEventListener<UserUpdatedPayload>("USER_UPDATE", (payload) => {
      if (payload.mentorshipId !== mentorshipId) return;
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === "mentorship" &&
          query.queryKey[2] === payload.userId,
      });
    });
  }, [addEventListener, mentorshipId, queryClient]);
}
